import { render, staticRenderFns } from "./catalogTypes.vue?vue&type=template&id=535dedd5&scoped=true"
import script from "./catalogTypes.vue?vue&type=script&lang=js"
export * from "./catalogTypes.vue?vue&type=script&lang=js"
import style0 from "./catalogTypes.vue?vue&type=style&index=0&id=535dedd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535dedd5",
  null
  
)

export default component.exports